import { Auth } from 'aws-amplify';
/************************* Public functions *************************/

export function authenticatedPostRequest(url, data) {
    return new Promise((resolve, reject) => {
        Auth.currentSession()
            .then(resp => resp.getIdToken().getJwtToken())
            .then(jwtToken => {                
                return makePostRequest(url, jwtToken, data);
            })
            .then(data => {
                resolve(data);
            })
            .catch(error => {
                console.log('makePostRequest error', error);
                //@@@ckl  This is a terrible hack that is also repeated below in
                //authenticatedGetRequest and authenticatedDeleteRequest.  What we SHOULD be doing
                //is letting the error propagate and let the caller handle it.  Resetting the window
                //location is a nuclear option. 
                if (error.message === '401' || error === 'No current user') {
                    window.location.href = process.env.REACT_APP_WWW_URL + '/login';
                }

                reject(error); // Re-throw to maintain rejection for other errors
            });
    });
}

export function authenticatedGetRequest(url) {
    return new Promise((resolve, reject) => {
        Auth.currentSession()
            .then(resp => resp.getIdToken().getJwtToken())
            .then(jwtToken => {
                return makeGetRequest(url, jwtToken);
            })
            .then(data => {
                resolve(data);
            })
            .catch(error => {
                console.log('makeGetRequest error', error);
                if (error.message === '401' || error === 'No current user') {
                    window.location.href = process.env.REACT_APP_WWW_URL + '/login';
                }

                reject(error); // Re-throw to maintain rejection for other errors
            });
    });
}

export function authenticatedDeleteRequest(url) {
    return new Promise((resolve, reject) => {
        Auth.currentSession()
            .then(resp => resp.getIdToken().getJwtToken())
            .then(jwtToken => {
                return makeDeleteRequest(url, jwtToken);
            })
            .then(data => {
                resolve(data);
            })
            .catch(error => {
                console.log('makeDeleteRequest error', error);
                if (error.message === '401' || error === 'No current user') {
                    window.location.href = process.env.REACT_APP_WWW_URL + '/login';
                }

                reject(error); // Re-throw to maintain rejection for other errors
            });
    });
}

export function authenticatedStreamingRequest(url, data) {
    return new Promise((resolve, reject) => {
        Auth.currentSession()
            .then(resp => resp.getIdToken().getJwtToken())
            .then(jwtToken => {
                return makeStreamingRequest(url, jwtToken, data);
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                console.log('makeStreamingRequest error', error);
                if (error.message === '401' || error === 'No current user') {
                    window.location.href = process.env.REACT_APP_WWW_URL + '/login';
                }

                reject(error); // Re-throw to maintain rejection for other errors
            });
    });
}



/************************* TODO: Make these private *************************/

export function makePostRequest(url, accessToken, data) {
    const headers = new Headers();
    //headers.append('Access-Control-Allow-Origin', process.env.REACT_APP_BASE_URL);
    headers.append('Content-Type', 'application/json');

    if (accessToken) {
        headers.append('Authorization', 'Bearer ' + accessToken);
    }

    //console.log('data', data);
    const body = JSON.stringify(data);

    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: headers,
            body: body,
        })
            .then(response => {   
                if (response.status === 200) {
                    return response.json();
                } 

                return response.text().then(body => {
                    throw new Error(`${JSON.parse(body).error}` || `HTTP ${response.status} `) 
                });
            })
            .then(data => {
                resolve(data);
            })
            .catch((error) => {
                console.log('POST error', error);
                reject(error);
            });
    });
}

export function makeGetRequest(url, accessToken) {
    // console.log(accessToken);

    const headers = new Headers();
    // headers.append('Access-Control-Allow-Origin', '*');
    // headers.append('Content-Type', 'application/json');

    if (accessToken) {
        headers.append('Authorization', 'Bearer ' + accessToken);
    }

    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'GET',
            mode: 'cors',
            headers: headers //{'Authorization': accessToken},
        })
            .then(response => {     
                //throw new Error(response.status);           
                if (response.status === 200) {
                    return response.json()
                } 
                throw new Error(response.status);
            })
            .then(data => {
                //console.log('post data', data);
                resolve(data);
            })
            .catch((error) => {
                console.log('GET error', error);
                reject(error);
            });
    });
}

export function makeDeleteRequest(url, accessToken) {
    const headers = new Headers();
  
    if (accessToken) {
      headers.append('Authorization', 'Bearer ' + accessToken);
    }
  
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'DELETE',
        mode: 'cors',
        headers: headers,
      })
        .then(response => {
          if (response.status === 200 || response.status === 204) { // 204 No Content is also common for successful DELETE
            return response.json(); 
          } 
          throw new Error(response.status);
        })
        .then(data => {
          resolve(data);
        })
        .catch((error) => {
          console.log('DELETE error', error);
          reject(error);
        });
    });
  }

export function makeStreamingRequest(url, accessToken, data) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    if (accessToken) {
        headers.append('Authorization', 'Bearer ' + accessToken);
    }

    headers.append('Cache-Control', 'no-cache, no-store, must-revalidate');
    headers.append('Pragma', 'no-cache');
    headers.append('X-Accel-Buffering', 'no');

    const body = JSON.stringify(data);

    return new Promise((resolve, reject) => {
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            headers: headers,
            body: body,
        })
            .then(response => {
                // For streaming requests, we return the raw response
                // without parsing for errors, allowing the caller to handle the stream
                resolve(response);
            })
            .catch((error) => {
                console.log('Streaming POST error', error);
                reject(error);
            });
    });
}